import React from 'react';
import { fontFamily, colour, ActionButton, Input } from './GlobalStyles';
import { useSelector, useDispatch } from 'react-redux';
import { doorbellAction } from './actions';
import './MobileBookPage.css';

const DoorbellMobile = React.forwardRef((props, ref) => {

    const currentDoorbell = useSelector(state => state.doorbellAction);
    const dispatch = useDispatch();

    const styles = {
        headerText: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontWeight: 'normal',
            fontSize: '1.375em',
            textAlign: 'center'
        },
        back: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontSize: '0.875em',
            fontWeight: 'normal',
            textAlign: 'center',
            cursor: 'pointer'
        }
    }

    return (
        <div className="mobileBookPageOuterContainer">
            <h1 style={styles.headerText}>
                Inserisci il tuo citofono
            </h1>
            <div>
                <Input
                    value={currentDoorbell}
                    id="outlined"
                    label="Citofono"
                    inputProps={{
                        autoCapitalize: 'none',
                    }}
                    variant="outlined"
                    onChange={(text) => dispatch(doorbellAction(text.target.value))}
                />
                <div style={{ height: '2vh' }} />
                <ActionButton
                    ref={ref} {...props}
                    disabled={
                                currentDoorbell === "" ?
                                true
                                :
                                false
                            }
                >
                    Continua
                </ActionButton>
                <div style={{ height: '2vh' }} />
                <p
                    onClick={() => props.onBack()} 
                    style={styles.back}
                >
                    Indietro
                </p>
            </div>
        </div>
    )
})

export default DoorbellMobile;